import { combineReducers } from 'redux';

import { defaultReducers } from '@dndbeyond/character-rules-engine/es';

import appEnv from '../../Shared/reducers/appEnv';
import appInfo from '../../Shared/reducers/appInfo';
import confirmModal from '../../Shared/reducers/confirmModal';
import modal from '../../Shared/reducers/modal';
import sidebar from '../../Shared/reducers/sidebar';
import toastMessage from '../../Shared/reducers/toastMessage';
import sheet from './sheet';

const rootReducer = combineReducers({
    ...defaultReducers,
    appEnv,
    appInfo,
    sheet,
    modal,
    confirmModal,
    sidebar,
    toastMessage,
});

export default rootReducer;
